"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _batteryType = require("@/api/iot/batteryType");
var _branch = require("@/api/iot/branch");
var _terminalType = require("@/api/iot/terminalType");
var _status = require("@/api/iot/status");
var _battery = require("@/api/iot/battery");
var _default = {
  props: ['editItem', 'lockStatusList'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        merchant_id: '',
        branch_id: '',
        terminal_no: '',
        battery_no: '',
        // terminal_type_id: '',
        battery_type_id: '',
        // sure_status: '',
        battery_status: '',
        lock_status: 0,
        // max_voltage: '',
        // charg_current: '',
        // soc: '',
        // bms_account: '',
        // bms_password: '',
        macid: ''
      },
      batteryStatusList: [],
      rules: {
        username: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        role_id: [{
          required: true,
          message: '请选择终端状态',
          trigger: 'change'
        }]
      },
      batteryTypeList: [],
      merchantList: [],
      branchList: [{
        id: 0,
        name: '无'
      }],
      terminalTypeList: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '电池管理';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getBatteryTypeList();
    this.getBatteryStatusList();
    this.getBranchlList();
    // this.getTerminalType()
  },

  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _batteryType.batteryTypeList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.batteryTypeList = res.data;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    getBatteryStatusList: function () {
      var _getBatteryStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _status.getBatteryStatusList)();
              case 2:
                res = _context3.sent;
                if (res) {
                  this.batteryStatusList = res;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getBatteryStatusList() {
        return _getBatteryStatusList2.apply(this, arguments);
      }
      return getBatteryStatusList;
    }(),
    getBranchlList: function getBranchlList() {
      var _this2 = this;
      (0, _branch.branchGetList)().then(function (res) {
        var _this2$branchList;
        (_this2$branchList = _this2.branchList).push.apply(_this2$branchList, (0, _toConsumableArray2.default)(res));
      });
    },
    getTerminalType: function getTerminalType() {
      var _this3 = this;
      (0, _terminalType.terminalTypeList)().then(function (res) {
        _this3.terminalTypeList = res;
      });
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _battery.batterySave)(_this4.form).then(function (res) {
            _this4.dialogVisible = false;
            _this4.$emit('getList', true);
          });
        } else {
          _this4.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;